import React from "react";
import Layout from "../../components/layouts/Layout";

const Contact = () => {
  return (
    <>
      <Layout>
        <h4>Contact</h4>
      </Layout>
    </>
  );
};

export default Contact;
